import { h } from 'preact';
import clsx from 'clsx';
import useTimer from './hooks/useTimer';
import TimeUnit from './time-unit';

const TIME_UNITS = [
  {
    key: 'days',
    singular: 'Day',
    plural: 'Days',
  },
  {
    key: 'hours',
    singular: 'Hour',
    plural: 'Hours',
  },
  {
    key: 'minutes',
    singular: 'Min',
    plural: 'Mins',
  },
  {
    key: 'seconds',
    singular: 'Sec',
    plural: 'Secs',
  },
];

const Timer = ({
  endDate,
  template = 'spd',
  header,
  className,
  customClasses,
}) => {
  const isGold = template === 'gld';
  const { timeLeft, isExpired } = useTimer(endDate, template);

  if (!endDate || isExpired) return null;

  return (
    <div
      className={clsx(
        'flex flex-col gap-2.5 items-center text-center',
        {
          'text-white spd-utility': !isGold,
          'text-spd-black gld-utility': isGold,
        },
        className,
      )}
      role="timer"
      aria-live="polite"
    >
      {header && (
        <span
          className={clsx(
            {
              'spd-utility font-bold': !isGold,
              'gld-utility text-white font-bold': isGold,
            },
            customClasses,
          )}
        >
          {header}
        </span>
      )}
      <div className="flex justify-center items-center gap-4">
        {TIME_UNITS.map((unit) => (
          <TimeUnit
            key={unit.key}
            value={timeLeft[unit.key]}
            unit={unit}
            isGold={isGold}
          />
        ))}
      </div>
    </div>
  );
};

export default Timer;
